/*
 * GoalStepsContainer.js 22.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import getStepsByGoal from '../../queries/getStepsByGoal.graphql';
import {graphql} from 'react-apollo';
import {compose} from 'redux';
import GoalStepsDetailsItem from '../../components/detail/GoalStepsDetailsItem';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';


const withSteps = graphql(getStepsByGoal, {
    options: params => ({
        variables: {zielId: parseInt(params.match.params.goalId, 10)},
        fetchPolicy: 'network-only',
        pollInterval: 60000
    }),
    props: ({ownProps, data}) => {

        if (data.loading || !data.getSchritteByZielId) {
            return {
                goalStepsLoading: true,
                goalSteps: [],
                refetchGoalSteps: data.refetch
            };
        }

        if (data.error) {
            return {hasErrors: true, goalSteps: []};
        }

        return {
            goalSteps: [...data.getSchritteByZielId].filter(step => step.aufgabeTeilnehmer || step.aufgabe || step.professionen.find(p => p.aufgabe)),
            refetchGoalSteps: data.refetch,
            ...ownProps
        };
    }
});


const mapStateToProps = ({sort, participant}) => ({sort, participant});

export default withRouter(compose(connect(mapStateToProps, {}), withSteps)(GoalStepsDetailsItem));



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/detail/GoalStepsContainer.js